import cls from 'classnames';

import SvgIcon from '../../../core/SvgIcon';

import useStyles from './styles';
import { IColorCopyProps } from './types';

export default function ColorCopy({
  className,
  element = 'div',
  type,
  onCopyClick,
  value,
}: IColorCopyProps) {
  const classes = useStyles();
  const Tag = element;

  return (
    <Tag className={cls(classes.root, className)}>
      <ul className={classes.list}>
        <li className={classes.type}>{type}</li>
        <li className={classes.value} onClick={() => onCopyClick(value, 'filed_click')}>
          {value}
        </li>
        <li>
          <button className={classes.copyBtn} onClick={() => onCopyClick(value, 'copy_icon')}>
            <SvgIcon className={classes.icon} name="icon-copy" />
          </button>
        </li>
      </ul>
    </Tag>
  );
}
